/* eslint-disable @typescript-eslint/no-unused-vars */
import EnvVars from 'helpers/envVars';
import routesPath from 'config/routesPath';
import { userType } from 'constants/userAccess';
import { CorportativeSaleIds } from 'helpers/corporativeSaleServicesToggleWithResaleProposals';

const MR_APPS_DOMAIN = EnvVars('MR_APPS_BASE_URL');

const menuTree = (dealerId, website) => [
  {
    id: 'feirao',
    name: 'feirao',
    label: 'Feirão',
    link: routesPath.getRecursivePath(routesPath.feirao, { dealerId }),
    icon: 'feirao',
    product: 'BIG_DEAL',
  },
  {
    id: 'inicio',
    name: 'Início',
    label: 'Início',
    link: routesPath.getRecursivePath(routesPath.mobigestorHomeByDealerId, {
      dealerId,
    }),
    icon: 'inicio',
  },
  {
    id: 'recepcao',
    name: 'recepcao',
    label: 'Recepção',
    link: routesPath.getRecursivePath(routesPath.reception, {
      dealerId,
    }),
    icon: 'reception',
    products: 'LEAD_MANAGER',
    extraUserTypeAccess: [
      userType.SALES_MANAGER.name,
      userType.RECEPTIONIST.name,
    ],
  },
  {
    id: 'mobiApp',
    name: 'mobiApp',
    icon: 'MrApps',
    label: 'Mobi App',
    externalLink: `${MR_APPS_DOMAIN}?dealerId=${dealerId}`,
    product: 'MOBI_DEALER_APP',
  },
  {
    id: 'evaluation',
    name: 'evaluation',
    label: 'Avaliação de Veículo',
    icon: 'montadora',
    // link: routesPath.getRecursivePath(routesPath.evaluations, {
    //   dealerId,
    // }),
    link: `${routesPath.evaluations}-dropdown`,
    links: [
      `${routesPath.evaluations}-dropdown`,
      routesPath.evaluations,
      routesPath.evaluationConfig,
      routesPath.evaluationReports,
    ],
    product: 'EVALUATE',
    permission: 'VIEW_EVALUATION',
    children: [
      {
        id: 'evaluationgeneralview',
        name: 'Visão Geral',
        label: 'Visão Geral',
        link: routesPath.getRecursivePath(routesPath.evaluations, {
          dealerId,
        }),
      },
      {
        id: 'evaluationReports',
        name: 'Relatórios',
        label: 'Relatórios',
        link: routesPath.getRecursivePath(routesPath.evaluationReports),
      },
      {
        id: 'evaluationconfig',
        name: 'Configurações',
        label: 'Configurações',
        link: routesPath.getRecursivePath(routesPath.evaluationConfig),
        extraUserTypeAccess: [
          userType.OWNER.name,
          userType.SALES_MANAGER.name,
          userType.DIRECTOR.name,
        ],
      },
    ],
  },
  {
    id: 'patioSystemControl',
    name: 'patioSystemControl',
    label: 'Gestão de Pátio',
    icon: 'patioSystemControl',
    link: routesPath.getRecursivePath(routesPath.patioSystemControl, {
      dealerId,
    }),
    product: 'PATIO_CONTROL',
  },
  {
    id: 'estoque',
    name: 'Estoque',
    label: 'Estoque',
    icon: 'estoqueLoja',
    link: `${routesPath.storeInvetory}-dropdown`,
    links: [
      `${routesPath.storeInvetory}-dropdown`,
      routesPath.storeInvetory,
      routesPath.manageReports,
    ],
    product: 'PROPOSAL_APPLICATION',
    enableToPrivilegedEmail: true,
    children: [
      {
        id: 'estoqueLoja',
        name: 'Estoque',
        label: 'Veículos',
        link: routesPath.getRecursivePath(routesPath.storeInvetory, {
          dealerId,
        }),
        product: 'PROPOSAL_APPLICATION',
        enableToPrivilegedEmail: true,
      },
      {
        id: 'relatorios',
        name: 'Relatórios',
        label: 'Relatórios',
        link: routesPath.getRecursivePath(routesPath.manageReports, {
          dealerId,
        }),
        permission: 'VIEW_INVOICE_REPORT',
        enableToPrivilegedEmail: true,
      },
    ],
  },
  ...(CorportativeSaleIds.includes(Number(dealerId))
    ? [
        {
          id: 'corporateSalesManager',
          name: 'Gestor Venda Corporativa',
          label: 'Gestor Venda Corporativa',
          icon: 'corporateSalesManager',
          link: `${routesPath.corporateSalesManagerConfig}-dropdown`,
          links: [
            `${routesPath.corporateSalesManagerConfig}-dropdown`,
            routesPath.corporateSalesManagerConfig,
          ],
          children: [
            {
              id: 'resaleStock',
              name: 'Meus Anúncios',
              label: 'Meus Anúncios',
              link: routesPath.getRecursivePath(routesPath.resaleStock, {
                dealerId,
              }),
            },
            {
              id: 'resaleProposals',
              name: 'Propostas',
              label: 'Propostas',
              link: routesPath.getRecursivePath(routesPath.resaleProposals, {
                dealerId,
              }),
            },
            {
              id: 'corporateSalesManagerConfig',
              name: 'Configurações',
              label: 'Configurações',
              link: routesPath.getRecursivePath(
                routesPath.corporateSalesManagerConfig,
                {
                  dealerId,
                }
              ),
            },
          ],
        },
      ]
    : []),
  {
    id: 'mobiOne',
    name: 'mobiOne',
    label: 'MobiOne (ADM)',
    icon: 'mobiOne',
    product: 'MOBIONE',
    link: `${routesPath.mobiOneStoreInvetory}-dropdown`,
    links: [
      `${routesPath.mobiOneStoreInvetory}-dropdown`,
      routesPath.mobiOneStoreInvetory,
      routesPath.mobiOneFinancial,
      routesPath.mobiOneForwardingAgent,
      routesPath.mobiOneInvoice,
      routesPath.mobiOneStoreSettings,
    ],

    children: [
      {
        id: 'estoque',
        name: 'Estoque',
        label: 'Estoque',
        link: routesPath.getRecursivePath(routesPath.mobiOneStoreInvetory, {
          dealerId,
        }),
        permission: 'VIEW_STOCK',
      },
      {
        id: 'financeiro',
        name: 'financeiro',
        label: 'Financeiro',
        link: routesPath.getRecursivePath(routesPath.mobiOneFinancial, {
          dealerId,
        }),
        permission: 'VIEW_FINANCIAL',
        extraUserTypeAccess: ['FINANCING'],
      },
      {
        id: 'pagamentosETransferencias',
        name: 'pagamentosETransferencias',
        label: 'Pagamentos e transferências',
        link: routesPath.getRecursivePath(
          routesPath.mobiOnePaymentsAndTransfers,
          {
            dealerId,
          }
        ),
        permission: 'VIEW_PAYMENTS_TRANSFERENCES',
        extraUserTypeAccess: ['FINANCING'],
      },
      {
        id: 'despachante',
        name: 'despachante',
        label: 'Despachante',
        link: routesPath.getRecursivePath(routesPath.mobiOneForwardingAgent, {
          dealerId,
        }),
        permission: 'VIEW_DISPATCHER',
        extraUserTypeAccess: ['FINANCING'],
      },
      {
        id: 'fiscal',
        name: 'fiscal',
        label: 'Fiscal',
        link: routesPath.getRecursivePath(routesPath.mobiOneInvoice, {
          dealerId,
        }),
        permission: 'VIEW_TAX',
        extraUserTypeAccess: ['FINANCING'],
      },

      {
        id: 'configuracoes',
        name: 'configuracoes',
        label: 'Configurações',
        link: routesPath.getRecursivePath(routesPath.mobiOneSettings, {
          dealerId,
        }),
        permission: 'VIEW_CONFIGURATIONS',
        extraUserTypeAccess: ['FINANCING'],
      },
    ],
  },
  {
    id: 'estoqueLoja',
    name: 'Estoque',
    icon: 'estoqueLoja',
    label: 'Estoque',
    link: routesPath.getRecursivePath(routesPath.storeInvetory, {
      dealerId,
    }),
    product: 'INVENTORY',
  },
  {
    id: 'estoque',
    name: 'Estoque',
    label: 'Publicação de Anúncio',
    icon: 'estoque',
    products: [
      'CLASSIFIED_USED_TOTAL',
      'CLASSIFIED_0KM_TOTAL',
      'STOCK_INTEGRATOR',
    ],
    link: `${routesPath.myDeals}-dropdown`,
    links: [
      `${routesPath.myDeals}-dropdown`,
      routesPath.myDeals,
      routesPath.performance,
      routesPath.manageProviders,
    ],
    permission: 'VIEW_DEAL',
    enableToPrivilegedEmail: true,
    children: [
      {
        id: 'meusAnuncios',
        name: 'Meus anúncios',
        label: 'Meus anúncios',
        link: routesPath.getRecursivePath(routesPath.myDeals, {
          dealerId,
        }),
        enableToPrivilegedEmail: true,
      },
      {
        id: 'performance',
        name: 'Performance',
        label: 'Performance',
        link: routesPath.getRecursivePath(routesPath.performance, {
          dealerId,
        }),
        enableToPrivilegedEmail: true,
      },
      {
        id: 'configuracoes',
        name: 'configuracoes',
        label: 'Configurações',
        link: routesPath.getRecursivePath(routesPath.stockPublicationSettings, {
          dealerId,
        }),
        enableToPrivilegedEmail: true,
        extraUserTypeAccess: [
          userType.OWNER.name,
          userType.SALES_MANAGER.name,
          userType.DIRECTOR.name,
        ],
      },

      {
        id: 'garantiaDeUmAno',
        name: 'garantiaDeUmAno',
        icon: 'TooMechanicalWarranty',
        label: 'Garantia Mecânica',
        link: routesPath.getRecursivePath(routesPath.mechanicalWarranty),
        products: [
          'TOO_MECHANICAL_WARRANTY',
          'TOO_MECHANICAL_WARRANTY_INACTIVE',
        ],
      },
    ],
  },
  {
    id: 'lead-manager',
    name: 'Gestor de Leads',
    label: 'Gestor de Leads',
    icon: 'propostas',
    products: ['CLASSIFIED_USED_TOTAL', 'CLASSIFIED_0KM_TOTAL', 'LEAD_MANAGER'],
    enableToPrivilegedEmail: true,
    link: `${routesPath.proposals}-dropdown`,
    links: [
      `${routesPath.proposals}-dropdown`,
      routesPath.proposals,
      routesPath.proposalsConfig,
    ],
    children: [
      {
        id: 'propostas',
        name: 'Propostas',
        label: 'Propostas',
        link: routesPath.getRecursivePath(routesPath.proposals, {
          dealerId,
        }),
      },
      {
        id: 'conversas',
        name: 'conversas',
        label: 'Conversas',
        link: routesPath.getRecursivePath(routesPath.conversations, {
          dealerId,
        }),
      },
      {
        id: 'leadQualifier',
        name: 'leadQualifier',
        label: 'Qualificador de Leads',
        link: routesPath.getRecursivePath(routesPath.leadQualifier, {
          dealerId,
        }),
        financingBancoPanEnabled: true,
      },
      {
        id: 'goalManager',
        name: 'goalManager',
        label: 'Painel de Produtividade',
        link: routesPath.getRecursivePath(routesPath.goalManager, {
          dealerId,
        }),
        product: 'GOALS_MANAGEMENT',
      },
      {
        id: 'financingMonitor',
        name: 'financingMonitor',
        label: 'Monitor de Financiamentos',
        permission: 'VIEW_FINANCIAL_MONITOR',
        externalLink: (
          externalIdentification,
          currentDealerCnpj,
          currentUserCPF
        ) => {
          const currentUserCPF11Characters = currentUserCPF?.padStart(11, '0');
          const fandiUrl = `https://${externalIdentification}/IntegracaoDMS.aspx?ReturnUrl=IntegracaoDMSInciarIntegracaoForm.aspx?monitoracao=true,cpf=${currentUserCPF11Characters},CnpjLoja=${currentDealerCnpj}`;
          return fandiUrl;
        },
      },
      {
        id: 'approvals',
        name: 'Aprovações',
        label: 'Aprovações',
        link: routesPath.getRecursivePath(routesPath.approvals),
        extraUserTypeAccess: [
          userType.OWNER.name,
          userType.SALES_MANAGER.name,
          userType.DIRECTOR.name,
        ],
      },
      {
        id: 'actionPlans',
        name: 'actionPlans',
        label: 'Planos de ação',
        link: routesPath.getRecursivePath(routesPath.actionPlansByDealerId),
        extraUserTypeAccess: [
          userType.OWNER.name,
          userType.SALES_MANAGER.name,
          userType.DIRECTOR.name,
        ],
      },
      {
        id: 'dailyMeeting',
        name: 'dailyMeeting',
        label: 'Reunião diária',
        product: 'QUALITYASSURANCE_DAILYMEETINGS',
        link: routesPath.getRecursivePath(routesPath.dailyMeeting, {
          dealerId,
        }),
        extraUserTypeAccess: [
          userType.OWNER.name,
          userType.SALES_MANAGER.name,
          userType.DIRECTOR.name,
        ],
        permission: [
          'VIEW_DAILY_MEETING',
          'CREATE_DAILY_MEETING',
          'EDIT_DAILY_MEETING',
          'FINISH_DAILY_MEETING',
        ],
      },
      {
        id: 'relatorios',
        name: 'Relatórios',
        label: 'Relatórios',
        link: routesPath.getRecursivePath(routesPath.manageReports, {
          dealerId,
        }),
        permission: 'VIEW_INVOICE_REPORT',
        enableToPrivilegedEmail: true,
      },

      {
        id: 'configuracoes',
        name: 'configuracoes',
        label: 'Configurações',
        link: routesPath.getRecursivePath(routesPath.proposalsConfig, {
          dealerId,
        }),
        enableToPrivilegedEmail: true,
        extraUserTypeAccess: [
          userType.OWNER.name,
          userType.SALES_MANAGER.name,
          userType.DIRECTOR.name,
        ],
      },
      {
        id: 'seller_wallet',
        name: 'seller_wallet',
        label: 'Carteira Vendedor',
        link: routesPath.getRecursivePath(routesPath.sellerWallet, {
          dealerId,
        }),
        onlySaga: true,
      },
    ],
  },
  {
    id: 'crm',
    name: 'Marketing',
    label: 'Marketing',
    icon: 'crm',
    products: ['CAMPAIGN', 'AUTOMATION', 'WHATSAPP'],
    link: `${routesPath.crmCampaigns}-dropdown`,
    links: [`${routesPath.crmCampaigns}-dropdown`, routesPath.crmCampaigns],
    extraUserTypeAccess: ['MARKETING'],
    children: [
      {
        id: 'campaigns',
        name: 'Campanhas',
        label: 'Campanhas',
        link: routesPath.getRecursivePath(routesPath.crmCampaigns, {
          dealerId,
        }),
        product: 'CAMPAIGN',
      },
      {
        id: 'automation',
        name: 'automation',
        label: 'Automações',
        link: routesPath.getRecursivePath(routesPath.automation, {
          dealerId,
        }),
        product: 'AUTOMATION',
      },
      {
        id: 'templates',
        name: 'templates',
        label: 'Templates',
        link: routesPath.getRecursivePath(routesPath.crmTemplates, {
          dealerId,
        }),
        products: ['CAMPAIGN', 'WHATSAPP'],
        permission: 'VIEW_TEMPLATE',
      },
      {
        id: 'whatsappSender',
        name: 'whatsappSender',
        label: 'WhatsApp',
        link: routesPath.getRecursivePath(routesPath.whatsappSender, {
          dealerId,
        }),
        enableToPrivilegedEmail: true,
        product: 'WHATSAPP',
      },
      {
        id: 'segmentation',
        name: 'segmentation',
        label: 'Segmentação',
        link: routesPath.getRecursivePath(routesPath.segmentation, {
          dealerId,
        }),
        permission: 'VIEW_SEGMENTATION_LIST',

        enableToPrivilegedEmail: true,
      },
    ],
  },
  // TODO: REMOVE/DELETE MODULO AND ARCHIVED AND CONFIG
  // {
  //   id: 'financeiro',
  //   name: 'Financeiro',
  //   label: 'Financeiro',
  //   icon: 'financeiro',
  //   product: 'FINANCIAL',
  //   link: `${routesPath.financialGeneralView}-dropdown`,
  //   links: [
  //     `${routesPath.financialGeneralView}-dropdown`,
  //     routesPath.financialNewEntry,
  //     routesPath.financialVendorsAnalysis,
  //     routesPath.manageDeals,
  //     routesPath.managePendencies,
  //     routesPath.financialConfiguration,
  //   ],
  //   children: [
  //     {
  //       id: 'generalView',
  //       name: 'Visão Geral',
  //       label: 'Visão Geral',
  //       link: routesPath.getRecursivePath(routesPath.financialGeneralView, {
  //         dealerId,
  //       }),
  //       children: [],
  //     },
  //     {
  //       id: 'newEntry',
  //       name: 'Novo Lançamento',
  //       label: 'Novo Lançamento',
  //       link: routesPath.getRecursivePath(routesPath.financialNewEntry, {
  //         dealerId,
  //       }),
  //       children: [],
  //     },
  //     {
  //       id: 'vendorAnalysis',
  //       name: 'Análise dos Vendedores',
  //       label: 'Análise dos Vendedores',
  //       link: routesPath.getRecursivePath(routesPath.financialVendorsAnalysis, {
  //         dealerId,
  //       }),
  //       children: [],
  //     },
  //     {
  //       id: 'myDeals',
  //       name: 'Meus Veículos',
  //       label: 'Meus Veículos',
  //       link: routesPath.getRecursivePath(routesPath.manageDeals, {
  //         dealerId,
  //       }),
  //       children: [],
  //     },
  //     {
  //       id: 'pendencies',
  //       name: 'Pendências',
  //       label: 'Pendências',
  //       link: routesPath.getRecursivePath(routesPath.managePendencies, {
  //         dealerId,
  //       }),
  //       children: [],
  //     },
  //     {
  //       id: 'configuration',
  //       name: 'Configurações',
  //       label: 'Configurações',
  //       link: routesPath.getRecursivePath(routesPath.financialConfiguration, {
  //         dealerId,
  //       }),
  //       children: [],
  //     },
  //   ],
  // },
  {
    id: 'svm',
    name: 'SVM',
    label: 'SVM / F&I',
    icon: 'Financing',
    product: 'FINANCING',
    link: `${routesPath.financing}-dropdown`,
    links: [
      `${routesPath.financing}-dropdown`,
      routesPath.financing,
      routesPath.financialInstitutionsList,
    ],
    extraUserTypeAccess: ['FINANCING'],
    children: [
      {
        id: 'acompanhamento',
        name: 'Acompanhamento',
        label: 'Acompanhamento',
        link: routesPath.getRecursivePath(routesPath.financing, {
          dealerId,
        }),
      },
      {
        id: 'financingMonitor',
        name: 'financingMonitor',
        label: 'Monitor de Financiamentos',
        permission: 'VIEW_FINANCIAL_MONITOR',
        externalLink: (
          externalIdentification,
          currentDealerCnpj,
          currentUserCPF
        ) => {
          const currentUserCPF11Characters = currentUserCPF?.padStart(11, '0');
          const fandiUrl = `https://${externalIdentification}/IntegracaoDMS.aspx?ReturnUrl=IntegracaoDMSInciarIntegracaoForm.aspx?monitoracao=true,cpf=${currentUserCPF11Characters},CnpjLoja=${currentDealerCnpj}`;
          return fandiUrl;
        },
      },
      {
        id: 'financialInstitution',
        name: 'financialInstitution',
        label: 'Instituições Financeiras',
        link: routesPath.getRecursivePath(
          routesPath.financialInstitutionsList,
          {
            dealerId,
          }
        ),
      },
    ],
  },
  {
    id: 'mobiPhone',
    name: 'Mobi-Fone',
    label: 'Mobi-Fone',
    link: routesPath.getRecursivePath(routesPath.mobiPhone, {
      dealerId,
    }),
    icon: 'mobiPhone',
    product: 'MOBIPHONE',
    permission: 'CALL_ACCESS',
    extraUserTypeAccess: ['SALES_ASSISTENT'],
  },
  {
    id: 'mobioneContacts',
    name: 'contatos',
    label: 'Contatos',
    link: `${routesPath.contactsCustomers}-dropdown`,
    links: [
      `${routesPath.contactsCustomers}-dropdown`,
      routesPath.contactsCustomers,
      routesPath.contactsSuppliers,
    ],
    icon: 'contacts',
    product: 'CONTACT',
    permission: 'VIEW_CONTACT',
    children: [
      {
        id: 'clientes',
        name: 'Clientes',
        label: 'Clientes',
        link: routesPath.getRecursivePath(routesPath.contactsCustomers, {
          dealerId,
        }),
      },
      {
        id: 'fornecedores',
        name: 'Fornecedores',
        label: 'Fornecedores',
        link: routesPath.getRecursivePath(routesPath.contactsSuppliers, {
          dealerId,
        }),
        products: ['MOBIONE', 'PATIO_CONTROL'],
      },
    ],
  },
  {
    id: 'resaleScheduler',
    name: 'agenda',
    label: 'Agenda',
    link: routesPath.getRecursivePath(routesPath.resaleSchedulerContacts, {
      dealerId,
    }),
    icon: 'calendar',
    product: 'SCHEDULE',
  },
  {
    id: 'resaleBuy',
    name: 'resaleBuy',
    label: 'Passe Carros',
    icon: 'resaleBuy',
    product: 'REPASSE',
    badgeTitle: 'Novo',
    externalLink: `https://www.passecarros.com.br/passe-carros?initialize=${dealerId}`,
  },
  // {
  //   id: 'resaleBuy',
  //   name: 'resaleBuy',
  //   label: 'Comprar',
  //   icon: 'resaleBuy',
  //   product: 'REPASSE',
  //   link: `${routesPath.resaleBuyOfferPortal}-dropdown`,
  //   links: [
  //     `${routesPath.resaleBuyOfferPortal}-dropdown`,
  //     routesPath.resaleBuyOfferPortal,
  //     routesPath.resaleBuyProposals,
  //   ],
  //   children: [
  //     {
  //       id: 'offerPortal',
  //       name: 'offerPortal',
  //       label: 'Portal de Ofertas',
  //       link: routesPath.getRecursivePath(routesPath.resaleBuyOfferPortal, {
  //         dealerId,
  //       }),
  //     },
  //     {
  //       id: 'resaleProposalsSent',
  //       name: 'resaleProposalsSent',
  //       label: 'Propostas Enviadas',
  //       link: routesPath.getRecursivePath(routesPath.resaleBuyProposals, {
  //         dealerId,
  //       }),
  //     },
  //   ],
  // },
  ...(!CorportativeSaleIds.includes(Number(dealerId))
    ? [
        {
          id: 'resale',
          name: 'resale',
          label: 'Repasse',
          icon: 'resale',
          product: 'REPASSE_VENDA',
          link: `${routesPath.resaleStock}-dropdown`,
          links: [
            `${routesPath.resaleStock}-dropdown`,
            routesPath.resaleStock,
            routesPath.resaleProposals,
            routesPath.resaleConfig,
          ],
          children: [
            {
              id: 'resaleStock',
              name: 'resaleStock',
              label: 'Meus anúncios',
              link: routesPath.getRecursivePath(routesPath.resaleStock, {
                dealerId,
              }),
            },
            {
              id: 'resaleProposals',
              name: 'resaleProposals',
              label: 'Propostas',
              link: routesPath.getRecursivePath(routesPath.resaleProposals, {
                dealerId,
              }),
            },
            {
              id: 'resaleConfig',
              name: 'resaleConfig',
              label: 'Configurações',
              link: routesPath.getRecursivePath(routesPath.resaleConfig, {
                dealerId,
              }),
            },
          ],
        },
      ]
    : []),
  (website || '')?.includes('primeiramaosaga.com.br') && {
    id: 'saga_site',
    name: 'saga_site',
    label: 'PrimeiraMão',
    icon: 'sagaSite',
    badgeTitle: 'Novo',
    link: routesPath.getRecursivePath(routesPath.sagaSeminovosIframe, {
      dealerId,
    }),
  },
  {
    id: 'integraçoes',
    name: 'integrações',
    label: 'Integrações',
    link: routesPath.getRecursivePath(routesPath.manageProviders, {
      dealerId,
    }),
    icon: 'integracao',
    permission: 'VIEW_INTEGRATION',
  },
  {
    id: 'mobifi',
    name: 'Mobi-Fi',
    label: 'Mobi-Fi',
    link: routesPath.getRecursivePath(routesPath.mobifi, {
      dealerId,
    }),
    icon: 'mobiFi',
    product: 'MOBIFI',
  },
  {
    id: 'site',
    name: 'Site',
    label: 'Site',
    link: routesPath.getRecursivePath(routesPath.dealerSite, {
      dealerId,
    }),
    icon: 'dealerSite',
    product: 'SITE',
  },
  {
    id: 'mobiAnalytics',
    name: 'Mobi Analytics',
    label: 'Mobi Analytics',
    link: routesPath.getRecursivePath(routesPath.mobiAnalytics, {
      dealerId,
    }),
    icon: 'mobiAnalyticsIcon',
    product: 'SUPERSET',
    extraUserTypeAccess: [
      userType.OWNER.name,
      userType.SALES_MANAGER.name,
      userType.DIRECTOR.name,
    ],
  },
  {
    id: 'billing',
    name: 'billing',
    label: 'Minhas Faturas',
    icon: 'Faturamento',
    link: routesPath.getRecursivePath(routesPath.billings, {
      dealerId,
    }),
    enableToPrivilegedEmail: true,
    someOwner: true,
  },
  {
    id: 'config',
    name: 'Cadastro',
    label: 'Cadastro',
    link: routesPath.getRecursivePath(routesPath.formDealer, {
      dealerId,
    }),
    icon: 'config',
    extraUserTypeAccess: [
      userType.OWNER.name,
      userType.SALES_MANAGER.name,
      userType.DIRECTOR.name,
    ],
  },
];

export const menuTreeWholesale = (dealerId, website) => [
  {
    id: 'inicio',
    name: 'Início',
    label: 'Início',
    link: routesPath.getRecursivePath(routesPath.mobigestorHomeByDealerId, {
      dealerId,
    }),
    icon: 'inicio',
  },
  {
    id: 'corporateSalesManager',
    name: 'Gestor Estoque Atacado',
    label: 'Gestor Estoque Atacado',
    icon: 'corporateSalesManager',
    link: `${routesPath.corporateSalesManagerConfig}-dropdown`,
    links: [
      `${routesPath.corporateSalesManagerConfig}-dropdown`,
      routesPath.corporateSalesManagerConfig,
    ],
    product: 'PORTAL_ATACADO',

    children: [
      {
        id: 'resaleStock',
        name: 'Meus Anúncios',
        label: 'Meus Anúncios',
        link: routesPath.getRecursivePath(routesPath.resaleStock, {
          dealerId,
        }),
      },
      {
        id: 'corporateSalesManagerConfig',
        name: 'Configurações',
        label: 'Configurações',
        link: routesPath.getRecursivePath(
          routesPath.corporateSalesManagerConfig,
          {
            dealerId,
          }
        ),
      },
    ],
  },
  {
    id: 'lead-manager',
    name: 'Gestor de Leads',
    label: 'Gestor de Leads',
    icon: 'propostas',
    products: ['CLASSIFIED_USED_TOTAL', 'CLASSIFIED_0KM_TOTAL', 'LEAD_MANAGER'],
    enableToPrivilegedEmail: true,
    link: `${routesPath.proposals}-dropdown`,
    links: [
      `${routesPath.proposals}-dropdown`,
      routesPath.proposals,
      routesPath.proposalsConfig,
    ],
    children: [
      {
        id: 'propostas',
        name: 'Propostas',
        label: 'Propostas',
        link: routesPath.getRecursivePath(routesPath.proposals, {
          dealerId,
        }),
      },

      {
        id: 'configuracoes',
        name: 'configuracoes',
        label: 'Configurações',
        link: routesPath.getRecursivePath(routesPath.proposalsConfig, {
          dealerId,
        }),
        enableToPrivilegedEmail: true,
        extraUserTypeAccess: [
          userType.OWNER.name,
          userType.SALES_MANAGER.name,
          userType.DIRECTOR.name,
        ],
      },
    ],
  },
  {
    id: 'config',
    name: 'Cadastro',
    label: 'Cadastro',
    link: routesPath.getRecursivePath(routesPath.formDealer, {
      dealerId,
    }),
    icon: 'config',
    extraUserTypeAccess: [
      userType.OWNER.name,
      userType.SALES_MANAGER.name,
      userType.DIRECTOR.name,
    ],
  },
  {
    id: 'billing',
    name: 'billing',
    label: 'Minhas Faturas',
    icon: 'Faturamento',
    link: routesPath.getRecursivePath(routesPath.billings, {
      dealerId,
    }),
    enableToPrivilegedEmail: true,
    someOwner: true,
  },
  {
    id: 'mobioneContacts',
    name: 'contatos',
    label: 'Contatos',
    link: `${routesPath.contactsCustomers}-dropdown`,
    links: [
      `${routesPath.contactsCustomers}-dropdown`,
      routesPath.contactsCustomers,
      routesPath.contactsSuppliers,
    ],
    icon: 'contacts',
    product: 'CONTACT',
    permission: 'VIEW_CONTACT',
    children: [
      {
        id: 'clientes',
        name: 'Clientes',
        label: 'Clientes',
        link: routesPath.getRecursivePath(routesPath.contactsCustomers, {
          dealerId,
        }),
      },
      {
        id: 'fornecedores',
        name: 'Fornecedores',
        label: 'Fornecedores',
        link: routesPath.getRecursivePath(routesPath.contactsSuppliers, {
          dealerId,
        }),
        products: ['MOBIONE', 'PATIO_CONTROL'],
      },
    ],
  },
];

export default menuTree;
